import { render, staticRenderFns } from "./LayoutPerfil.vue?vue&type=template&id=d76c9dbe&scoped=true&"
import script from "./LayoutPerfil.vue?vue&type=script&lang=js&"
export * from "./LayoutPerfil.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPerfil.vue?vue&type=style&index=0&id=d76c9dbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76c9dbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContent,VRow})
